import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthModalService } from '../../../services/auth-modal.service';

@Component({
  selector: 'app-modal-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-login.component.html',
  styleUrl: './modal-login.component.scss',
})
export class ModalLoginComponent {
  private readonly modalService = inject(AuthModalService);

  email = '';
  password = '';
  captchaChecked = false;

  goToRegister(): void {
    this.modalService.switchTo('registro');
  }

  signIn(): void {
    // TODO: integrar con backend
    this.modalService.switchTo('verificacion');
  }
}
